import client from './client';

export const login = ({ userId, password }) =>
    client.post('/api/user/login', ({ userId, password }));

export const updatePassword = ({ userId, password, newPassword }) =>
    client.put('/api/user/password', ({ userId, password, newPassword }));
